import { createIcon } from '@chakra-ui/react';

export const Adult = createIcon({
  displayName: 'Adult',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect id="bg" width="24" height="24" fill="#fff" />
      <g id="SJ-Icon-B_Adult_Red_RGB" transform="translate(0.375 0.375)">
        <path
          id="Path_2311"
          data-name="Path 2311"
          d="M12.624,24.248A11.626,11.626,0,1,1,24.25,12.621,11.639,11.639,0,0,1,12.624,24.248Zm0-22.128a10.5,10.5,0,1,0,10.5,10.5A10.513,10.513,0,0,0,12.624,2.12Z"
          transform="translate(-0.998 -0.995)"
          fill="currentColor"
        />
        <path
          id="Path_2312"
          data-name="Path 2312"
          d="M26.992,18.854A3.005,3.005,0,1,1,30,15.849,3.009,3.009,0,0,1,26.992,18.854Zm0-4.885a1.88,1.88,0,1,0,1.88,1.88A1.882,1.882,0,0,0,26.992,13.969Z"
          transform="translate(-15.366 -8.401)"
          fill="currentColor"
        />
        <path
          id="Path_2313"
          data-name="Path 2313"
          d="M16.569,36.83a.563.563,0,0,1-.543-.711l.633-2.322a2.8,2.8,0,0,1,1.876-1.948,11.8,11.8,0,0,1,6.935,0A2.8,2.8,0,0,1,27.348,33.8l.633,2.322a.563.563,0,0,1-.542.711H18.444a.563.563,0,0,1,0-1.125H26.7l-.44-1.612a1.677,1.677,0,0,0-1.124-1.17,10.678,10.678,0,0,0-6.27,0,1.677,1.677,0,0,0-1.124,1.169l-.633,2.322A.562.562,0,0,1,16.569,36.83Z"
          transform="translate(-10.378 -19.954)"
          fill="currentColor"
        />
      </g>
    </>
  ),
});
